//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useCallback,
  useEffect,
  Fragment,
  useContext,
} from "react";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import { CustomerStatus } from "./config/config";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
import CustomerStatusXLSX from "./customXLSX";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
  },
})(() => null);

export default function CustomerStatusFunc(props) {
  const { state, dispatch } = useContext(Context);
  const { page, setDisableDropdown } = props;
  const { customerStatusAPI } = report();
  const classes = styles();
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    columns: [],
    dialog: false,
    data: [],
    response: false,
    startDate: new Date(),
    endDate: new Date(),
    dateApplied: false,
    type: "All",
    eLoading: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // setting checkboxes
  useEffect(() => {
    let label = CustomerStatus?.columns?.map((c) => c.label);
    setStates({ columns: label, selectedColumns: label });
  }, []);

  // CustomerStatus api func
  const handleGetCustomerStatus = async () => {
    try {
      setDisableDropdown(true);
      let values = {};
      values = {
        ...values,
        startDate: moment(states.startDate).format("MM/DD/YYYY"),
        endDate: moment(states.endDate).format("MM/DD/YYYY"),
      };

      let res = await customerStatusAPI(values);
      //console.log({ res });
      if (res && res.data) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        setStates({ data: res.data, response: true, eLoading: false });
        setDisableDropdown(false);
        return true;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const locale = i18n.language == 'fr' ? fr : enUS;

  return (
    <div>
      <GlobalCss />
      <div className={classes.headText}>
        {t('Select date range')}{" "}
        {states.dateApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  dateApplied: false,
                  startDate: new Date(),
                  endDate: new Date(),
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (
                    moment(moment(date).format("MM/DD/YYYY")).isAfter(
                      moment(states.endDate).format("MM/DD/YYYY")
                    )
                  ) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ startDate: null });
                    return;
                  }
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("End Date")}
                id="date-picker-inline2"
                className={classes.dateInput}
                value={states.endDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (
                    moment(moment(date).format("MM/DD/YYYY")).isBefore(
                      moment(states.startDate).format("MM/DD/YYYY")
                    )
                  ) {
                    toast.error("End date should be greater than Start date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ endDate: null });
                    return;
                  } else if (
                    moment(moment(date).format("MM/DD/YYYY")).isAfter(
                      moment(new Date()).format("MM/DD/YYYY")
                    )
                  ) {
                    setStates({ endDate: null });
                    toast.error("End date should be lesser that future date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ endDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </div>

      {/* <div className={classes.headText}>Select Type</div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        <Grid xs={12} md={3}>
          <TextField
            id={"group"}
            label={"Type"}
            select
            type={"text"}
            className={classes.groupInput}
            value={states.type}
            onChange={(e) => {
              setStates({
                type: e.target.value,
              });
            }}
          >
            {CustomerStatus.type.map((r, i) => (
              <MenuItem value={r.key} key={i}>
                {r.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid> */}

      <div className={classes.exportAndPreview}>
        {/* <Button
          className={classes.previewBtn}
          onClick={async () => {
            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }

            setStates({ response: false, data: [] });
            let res = await handleGetCustomerStatus();
            if (res) {
              setStates({ dialog: true });
            }
          }}
        >
          Preview
        </Button> */}
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid start date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid end date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }
            setStates({ response: false, data: [], eLoading: true });
            let res = await handleGetCustomerStatus();
            if (res) {
              document.getElementById("csv").click();
            }
          }}
          disabled={states.eLoading}
        >
          {states.eLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Export")
          )}
        </Button>
        <CustomerStatusXLSX
          states={states}
          date={
            moment(moment(states?.startDate).format("MM/DD/YYYY")).isSame(
              moment(states?.endDate).format("MM/DD/YYYY")
            )
              ? `Date : ${moment(states?.startDate).format("MM/DD/YYYY")}`
              : `Date : ${moment(states?.startDate).format(
                "MM/DD/YYYY"
              )} - ${moment(states?.endDate).format("MM/DD/YYYY")}`
          }
          page={page}
        />
      </div>

      <Dialog
        onClose={() => {
          setStates({ dialog: false });
        }}
        aria-labelledby="simple-dialog-title"
        open={states.dialog}
      >
        <div className={classes.mainDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.gridOne}>
              {page + " " + "Report"}
              <HighlightOffIcon
                className={classes.gridTwo}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              />
            </Grid>
            <Grid item xs={12} className={classes.gridFive}>
              <span className={classes.gridThreeSpan}>{t('Generated Date')} : </span>
              <span>{moment(new Date()).format("MM-DD-YYYY")}</span>
            </Grid>
          </Grid>
          {states.response ? (
            states.data && states.data.length > 0 ? (
              <TableContainer className={classes.tableContainer}>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  aria-label="enhanced table"
                >
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      {states.selectedColumns?.map((h, i) => (
                        <TableCell key={i} className={classes.tableHeading}>
                          <div>{h ? h : states.type}</div>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {states.data?.slice(0, 10)?.map((p, i) => (
                      <TableRow role="checkbox" tabIndex={-1} key={i}>
                        {[
                          "type",
                          "customer",
                          "fsc",
                          "program_admin",
                          "total",
                        ].map((s) => (
                          <TableCell align="left" className={classes.rowCell}>
                            {p?.[s]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <NoData />
            )
          ) : (
            <Loader Loading={!states?.response}></Loader>
          )}
        </div>
        {states.data && states.data.length > 0 && (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.gridFour}>
              <Button
                className={classes.previewBtn}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={classes.exportBtn}
                onClick={() => {
                  setStates({ dialog: false });
                  document.getElementById("csv").click();
                }}
              >
                {t('Export CSV')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Dialog>
    </div>
  );
}
